import {formatISO9075} from "date-fns";
import {Link} from "react-router-dom";

export default function Post({_id,title,summary,cover,content,createdAt,author, category}) {

  return (
    <div className="post">
      <div className="image">
        <Link to={`/post/${_id}`}>
          <img src={'https://ogtorgui.zyberapi.site/'+cover} alt=""/>
        </Link>
      </div>
      <div className="texts">
        <Link to={`/post/${_id}`}>
        <h2>{title}</h2>
        </Link>
        <p className="info">
          {/* <a className="author">{author.}</a> */}
          <time>{formatISO9075(new Date(createdAt))}</time>
        </p>
        <h4>{category}</h4>

        <p className="summary">{summary}</p>
      </div>
    </div>
  );
}